import React from "react"
import "./section4.scss"
import Img from "./img"
import Slick from "react-slick"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import data from "../data.json"

const community = data.community

class Section4 extends React.Component {
    constructor(props) {
        super(props)
        this.sliderRef = React.createRef()
    }

    state = {
        pics: [],
        currentGroup: 0
    }

    componentDidMount() {

        let pics = [];
        community.forEach((g, gIdex) => {
            g.photo.forEach((pic, pIdx) => {
                pics.push({
                        gIndex: gIdex,
                        pIndex: pIdx,
                        pic
                    }
                )
            })
        })
        this.setState({
            pics
        })
    }


    render() {

        let {pics} = this.state;
        return (
            <div className="community-panel">
                <div className="arrow-left">
                    <div className={`btn `} onClick={ ()=>{
                        // if(props.onPrev){
                        //     props.onPrev(props.current - 1);
                        // }
                        this.sliderRef.current.slickPrev()
                    }}>
                        <img src={`https://img.uigreat.com/pxfer/arrow-left.png`} draggable={false} alt=""/>
                    </div>
                </div>
                <Slick
                    dots={false}
                    infinite={true}
                    autoplay={true}
                    draggable={true}
                    arrows={false}
                    ref={this.sliderRef}
                    afterChange={(current) => {
                        let picObj = this.state.pics[current]
                        this.setState({
                            currentGroup: picObj.gIndex
                        })
                    }}
                >
                    {
                        pics.map((picObj, index) =>
                            <div className={`community-pic`} key={index}>
                                <img src={picObj.pic} alt=""/>
                            </div>)
                    }
                </Slick>
                <div className="arrow-right">
                    <div className={`btn `} onClick={ ()=>{
                        // if(props.onPrev){
                        //     props.onPrev(props.current - 1);
                        // }
                        this.sliderRef.current.slickNext()
                    }}>
                        <img src={`https://img.uigreat.com/pxfer/arrow-right.png`} draggable={false} alt=""/>
                    </div>
                </div>
                <div className="pic-group">
                    {
                        community.map((group, index) =>
                            <div className={`group-item ${this.state.currentGroup === index ? "group-active" : ""}  `}
                                 key={index}>
                                <Img className={"bg-shadow"} src={"https://img.uigreat.com/szpxfer/group-bg.png"}
                                     alt=""/>
                                <img className={"group-cover"} src={group.photo[0]} alt=""/>
                                <div className="group-name" style={{backgroundColor: `${group.groupnamecolor}`}}>
                                    #{group.groupname}#
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>

        )
    }
}

export default Section4

